import { createFileRoute } from '@tanstack/react-router'

import { SecurityPage } from '#/modules/auth/security-page'

export const Route = createFileRoute('/_shell/security')({
  component: SecurityPage,
})
